import maplibregl from "maplibre-gl";

/**
 * Time-based throttle (better than rAF for raster-heavy maps)
 * @param {Function} fn
 * @param {number} interval ms
 */
export function throttle(fn, interval = 33) {
  let last = 0;
  let pending = false;

  return function throttled() {
    const now = performance.now();
    if (now - last >= interval) {
      last = now;
      fn();
    } else if (!pending) {
      pending = true;
      setTimeout(() => {
        pending = false;
        last = performance.now();
        fn();
      }, interval - (now - last));
    }
  };
}

/**
 * Shared mutable LngLat to avoid allocations on every sync
 */
export function createReusableCenter() {
  return new maplibregl.LngLat(0, 0);
}